@if(visible()){
<!-- <div class="jk-edit-border" [ngStyle]="widthStyle"> -->
<div [ngStyle]="flexStyle">
  <div>
    <app-jkfieldlabel [displayLabel]="displayLabel()" [label]="label()" [required]="required()" [emojiLabel]="emojiLabel()">
    </app-jkfieldlabel>
  </div>
  <div class="w-full jk-margin0 flex items-center">

    <input matInput class="flex-1" [type]="inputType" [title]="label()" [(ngModel)]="value" [readonly]="readonly()"
      [disabled]="disabled()" [required]="required()" [placeholder]="placeholder" (change)="onValueChange($event)"
      [maxLength]="maxlength()">
    @if (type()==='password') {
    <button mat-icon-button (click)="togglePasswordVisibility($event)" type="button">
      <mat-icon>{{inputType==='password'?'visibility':'visibility_off'}}</mat-icon>
    </button>
    }
    <!--       @if (value && (!readonly())) {
      <button #close_btn matSuffix mat-mini-button aria-label="Clear" (click)="value=''" class="ml-1 flex-shrink-0">
        <mat-icon>close</mat-icon>
      </button>
      }
 -->
  </div>
</div>

<!-- </div> -->
}